import { Injectable } from '@angular/core';
import { Http, HttpModule, Headers, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { environment } from "environments/environment";
import { Observable } from 'rxjs/Rx';
import { PlatformLocation } from '@angular/common';
import { RestService } from "app/webservice/rest.service";

@Injectable()
export class RegisterService {

  public serviceStackUrl;
  
  constructor(
    private _http: Http, 
    private _restService: RestService,
    platformLocation: PlatformLocation
  ) {
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
  }

  register(registerObj) {
    const url = this.serviceStackUrl + 'register';
    return this._restService.post(url, registerObj);
  }

}


// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/register/register.service.ts